// extracted by mini-css-extract-plugin
export var columnItem = "_gl-3";
export var columnItemDraggable = "_gl-5";
export var dragHandle = "_gl-0";
export var dragHandleHovered = "_gl-1";
export var dropdown = "_gl-6";
export var dropdownContent = "_gl-8";
export var dropdownInner = "_gl-7";
export var filterDropdownHeader = "_gl-9";
export var icon = "_gl-2";
export var moveToTopButton = "_gl-4";
export var sectionDivider = "_gl-a";